import { BookingSearchParams } from '../../components/Booking/types'
import { BookingBookingPayload } from '../../services/booking/types'

export interface BookingSearchState {
  searchParams?: BookingSearchParams | undefined
  searchResults: BookingBookingPayload[]
  showSearch: boolean
}

export const initialBookingSearchState: BookingSearchState = {
  searchResults: [],
  showSearch: true,
}

const SET_SHOW_SEARCH = 'SET_SHOW_SEARCH'
const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS'
const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
const ADD_NEW_SEARCH_RESULTS = 'ADD_NEW_SEARCH_RESULTS'
const REMOVE_SEARCH_RESULT = 'REMOVE_SEARCH_RESULT'

interface SetDeskBookingShowSearch {
  type: typeof SET_SHOW_SEARCH
  payload: boolean
}

interface SetBookingSearchParams {
  type: typeof SET_SEARCH_PARAMS
  payload: BookingSearchParams | undefined
}

interface SetDeskBookingSearchResults {
  type: typeof SET_SEARCH_RESULTS
  payload: BookingBookingPayload[]
}

interface AddNewSearchResults {
  type: typeof ADD_NEW_SEARCH_RESULTS
  payload: BookingBookingPayload[]
}

interface RemoveSearchResult {
  type: typeof REMOVE_SEARCH_RESULT
  payload: number
}

type deskBookingSearchDespatchTypes =
  | SetDeskBookingShowSearch
  | SetBookingSearchParams
  | SetDeskBookingSearchResults
  | AddNewSearchResults
  | RemoveSearchResult

export const setDeskBookingShowSearch = (show: boolean): SetDeskBookingShowSearch => ({
  type: SET_SHOW_SEARCH,
  payload: show,
})

export const setDeskBookingSearchParams = (
  searchParams: BookingSearchParams | undefined
): SetBookingSearchParams => ({
  type: SET_SEARCH_PARAMS,
  payload: searchParams,
})

export const setDeskBookingSearchResults = (
  searchResults: BookingBookingPayload[]
): deskBookingSearchDespatchTypes => ({
  type: SET_SEARCH_RESULTS,
  payload: searchResults,
})

export const addNewSearchResults = (
  searchResults: BookingBookingPayload[]
): AddNewSearchResults => ({
  type: ADD_NEW_SEARCH_RESULTS,
  payload: searchResults,
})

export const removeSearchResult = (
  bookingId: number
): RemoveSearchResult => ({
  type: REMOVE_SEARCH_RESULT,
  payload: bookingId,
})

export const deskBookingSearchReducer = (
  state: BookingSearchState = initialBookingSearchState,
  action: deskBookingSearchDespatchTypes
): BookingSearchState => {
  switch (action.type) {
    case SET_SHOW_SEARCH:
      return { ...state, showSearch: action.payload }
    case SET_SEARCH_RESULTS:
      return { ...state, searchResults: action.payload }
    case SET_SEARCH_PARAMS:
      return { ...state, searchParams: action.payload }
    case ADD_NEW_SEARCH_RESULTS:
      return {
          ...state,
          searchResults: [
            ...state.searchResults,
            ...action.payload.filter(f => f.statusId === 2 && state.searchResults.find(s => s.id === f.id) === undefined)],
        }
    case REMOVE_SEARCH_RESULT:
      return {
          ...state,
          searchResults: state.searchResults.filter(s => s.id !== action.payload),
        }
    default:
      return state
  }
}
